"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComputeCache = void 0;
var ComputeCacheEntry_1 = require("./ComputeCacheEntry");
/**
 * Used to cache results of heavy computations.
 */
var ComputeCache = /** @class */ (function () {
    function ComputeCache(_getTimestamp) {
        if (_getTimestamp === void 0) { _getTimestamp = function () { return Date.now(); }; }
        this._getTimestamp = _getTimestamp;
        this._entriesByKey = {};
    }
    /**
     * Accesses a value from the cache. Computes and stores it if needed.
     *
     * @param key A key identifying the value within the cache.
     * @param provider The computation to run if the value is not present.
     */
    ComputeCache.prototype.access = function (key, provider) {
        var entry = this._entriesByKey[key];
        if (!entry) {
            entry = new ComputeCacheEntry_1.ComputeCacheEntry(provider(), this._getTimestamp);
            this._entriesByKey[key] = entry;
        }
        return entry.access();
    };
    /**
     * Deletes stale entries from the cache.
     *
     * @param msLifetime The time after which cache entries that aren't accessed turn stale.
     */
    ComputeCache.prototype.gc = function (msLifetime) {
        var e_1, _a;
        if (msLifetime === void 0) { msLifetime = 10 * 1000; }
        try {
            for (var _b = __values(Object.entries(this._entriesByKey)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), key = _d[0], entry = _d[1];
                if (entry.isStale(msLifetime)) {
                    delete this._entriesByKey[key];
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    return ComputeCache;
}());
exports.ComputeCache = ComputeCache;
//# sourceMappingURL=ComputeCache.js.map